
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus();
import { Technologia } from "./Technologia";
import FinderVue from "@/finder/Finder.vue";
import Store from "@/store/Store"; 
import { MasterData } from "@/store/MasterData"; 
import  ButtonVue from "@/lib/Button.vue";
import { Finder } from "@/finder/IFinder";
import { ITechnologia } from "./ITechnologia";

@Component({ components: { FinderVue, ButtonVue} })
export default class TechnologiaVue extends Vue {
  @Prop(Object) technologia!: Technologia;
  
  //@Prop(Array) komponent_defs: any[] = [];
  key: number = 0;
  komponenty:any=[]
  komponenty_farba:any=[]

  wydatek_sito_puchn:number=0
   
  typy_sita_puchn=[{nazwa:'HV', wydatek:17.0},{nazwa:'DW',wydatek:45.0},{nazwa:'BZ',wydatek:300.0}]
  procenty:number[]= [0,10,20,30,40,50,60,70,80,90,91,92,93,94,95,97,98,99, 100,101, 102,103, 104, 105, 106,107,108,109,110,120,130,140,150,160,170,180,190,200]
  krotnosci:number[]=[1,2,3,4,5]

  has_komponenty:boolean=false
  has_komponenty_farba:boolean=false

  tk=0
  async mounted() {

    bus.register("komponent_selected"+this.technologia.id, this.komponent_selected)
    bus.register("komponent_farba_selected"+this.technologia.id, this.komponent_farba_selected)
    bus.register("masterdata_refresh",this.refresh_masterdata)

    await this.refresh_masterdata()   
    this.key++;

  }

  async refresh_masterdata() {

    const masterData: MasterData|undefined =  await (await new Store().getStore()).masterData;

    if (!masterData) return;
    //console.log(this.technologia)
    const ett:string=  this.technologia.typ+'@'+this.technologia.etap_typ
    //console.log("refresh_masterdata for",ett)

    this.has_komponenty_farba=false
    this.komponenty_farba   = masterData.komponenty_new_zbiorcze[ett]
    if (this.komponenty_farba) {
      this.has_komponenty_farba=true;
      if (!this.technologia.komponent_farba_finder) this.technologia.komponent_farba_finder=new Finder();
      this.update_finder(this.technologia.komponent_farba_finder, this.komponenty_farba)
    }

    this.has_komponenty=false
    this.komponenty         = masterData.komponenty_new[ett]
    if (this.komponenty) {
      this.has_komponenty=true;
      if (!this.technologia.komponent_finder) this.technologia.komponent_finder=new Finder();
      this.update_finder(this.technologia.komponent_finder, this.komponenty)
    }
    this.key++
  }


  beforeDestroy() {
    bus.remove("komponent_selected"+this.technologia.id, this.komponent_selected)
    bus.remove("komponent_farba_selected"+this.technologia.id, this.komponent_farba_selected)
    bus.remove("masterdata_refresh",this.refresh_masterdata)
  }

  async update_finder(finder:Finder, kk:[]) {
    
    if (!finder._id) return;
    (<any> finder).changed = undefined;

    for (let i=0;i<kk.length;i++) {
      let k=<any> kk[i]
      if (k._id == finder._id) {
     
        if (k.text != finder.text) {
          
          (<any> finder).changed = k;
          k.data=finder.data
          k.filter=finder.filter
          this.key++
        }
      }
    }
  }

  change_finder(finder:Finder) {
    if (finder==this.technologia.komponent_finder) {
      finder.text=(<any> finder).changed.text
      bus.fire("komponent_selected"+this.technologia.id, (<any> finder).changed);
    } else if (finder==this.technologia.komponent_farba_finder) {
      finder.text=(<any> finder).changed.text
      bus.fire("komponent_farba_selected"+this.technologia.id, (<any> finder).changed);
    }
  }

  async komponent_selected(e:any) {

      const t=this.technologia
      t.komponent_finder = e.detail;
      const d=t.komponent_finder.data

      if (t.komponent_finder._id) {
        t.komponent_id = d.data_komponent_id,
        t.komponent_typ = d.data_komponent_typ
        t.komponent_nazwa = d.data_komponent_nazwa
        t.komponent_exact = d.data_komponent_exact
        t.komponent_exact_metry = d.data_komponent_exact_metry
        t.komponent_kolor = d. data_komponent_kolor
        t.komponent_polysk = d. data_komponent_polysk
        t.komponent_podklad = d. data_komponent_podklad
        t.komponent_grubosc_podkladu = d.data_komponent_grubosc_podkladu
        t.komponent_cena = d.data_komponent_cena
        t.komponent_jm = d.data_komponent_jm
        t.komponent_lead_time = d.data_komponent_lead_time
        t.komponent_wydatek = d.data_komponent_wydatek

      } else {
        t.komponent_id = 0
        t.komponent_typ = ''
        t.komponent_nazwa = ''
        t.komponent_exact = 0
        t.komponent_exact_metry = 0
        t.komponent_kolor = ''
        t.komponent_polysk = ''
        t.komponent_podklad = ''
        t.komponent_grubosc_podkladu = 0
        t.komponent_cena = 0
        t.komponent_jm = ''
        t.komponent_lead_time = 0
        t.komponent_wydatek = 0
      }
      await this.chg()
      
  }



  async komponent_farba_selected(e:any) {

      const t=this.technologia
      t.komponent_farba_finder = e.detail;
      const d=t.komponent_farba_finder.data
      
      //alert(JSON.stringify(d))

      if (d.data_komponent_id) {
        t.komponent_id = d.data_komponent_id,
        t.komponent_typ = d.data_komponent_typ
        t.komponent_nazwa = d.data_komponent_nazwa
        t.komponent_exact = d.data_komponent_exact
        t.komponent_exact_metry = d.data_komponent_exact_metry
        t.komponent_kolor = d. data_komponent_kolor
        t.komponent_polysk = d. data_komponent_polysk
        t.komponent_podklad = d. data_komponent_podklad
        t.komponent_grubosc_podkladu = d.data_komponent_grubosc_podkladu
        t.komponent_cena = d.data_komponent_cena
        t.komponent_jm = d.data_komponent_jm
        t.komponent_lead_time = d.data_komponent_lead_time
        t.komponent_wydatek = d.data_komponent_wydatek
     
      } else {
        t.komponent_id = 0
        t.komponent_typ = ''
        t.komponent_nazwa = ''
        t.komponent_exact = 0
        t.komponent_exact_metry = 0
        t.komponent_kolor = ''
        t.komponent_polysk = ''
        t.komponent_podklad = ''
        t.komponent_grubosc_podkladu = 0
        t.komponent_cena = 0
        t.komponent_jm = ''
        t.komponent_lead_time = 0
        t.komponent_wydatek = 0
      }
      await this.chg()
      
  }


  del_technologia(t:Technologia) {
    this.$emit("del_technologia", t)
  }

  async chg_zmiana() {
    await this.chg()
  }

  async chg() {
    console.log("chg")
    //alert(this.technologia.komponent_wydatek_sita_puchn)
    this.$emit("technologia_changed", {})
    this.key++;
  }

  set_kolor(c:any, old_c:any) {
    if (c && !this.technologia.kolor) {
      this.technologia.kolor = c;
      this.technologia.procent_pokrycia = c.pokrycie_procent;
      c.used=true;
    } else {
      this.technologia.kolor = undefined;
      this.technologia.procent_pokrycia = 100;
      old_c.used=false;
    }
    this.chg()
  }

  dbg(technologia:any) {
    if (technologia.dbg) technologia.dbg=0;
    else technologia.dbg=1;
    this.tk++
  }

}
